// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"7b4c9485","453":"72922285","732":"2d25a5f8","977":"80748151"}[chunkId] + ".chunk.js";
};